export default "__VITE_ASSET__DVmUZPBv__"